export default __webpack_public_path__ + "static/instapic-95309d910eb1f1571733be9c30092956.jpg";